import type { FileUsage } from '@vedalib/editor/lib/files'
import { FileUsageSource } from '@vedalib/editor/lib/files'

import type { IControlProps } from 'components/controls/Field/Field.types'
import FileLoader from 'components/uiKit/FileLoader'
import type { IFieldFileCommon } from 'components/uiKit/FileLoader/FileLoader'

export interface IFieldFileExtended extends IFieldFileCommon {
  value: FileUsage
}

/** @deprecated use [FormKit](../../../../components/formKit/fields/index.ts) */
const FieldFile: React.FC<IControlProps<IFieldFileExtended>> = ({
  value,
  onChange,
  name,
  fileType,
  defaultValue,
  onFocus,
  onBlur,
  ...rest
}) => {
  return (
    <FileLoader
      fileType={fileType}
      name={name}
      onBlur={onBlur}
      // @ts-expect-error TODO
      onChange={onChange}
      onFocus={onFocus}
      source={FileUsageSource.file}
      value={value ?? defaultValue}
      {...rest}
    />
  )
}

export default FieldFile
